import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i4 from '@angular/forms';
import { Validators, NG_VALUE_ACCESSOR, NG_VALIDATORS, FormsModule } from '@angular/forms';
import * as i0 from '@angular/core';
import { Pipe, EventEmitter, ElementRef, Component, ViewEncapsulation, Input, Output, ViewChild, HostListener, NgModule } from '@angular/core';
import { SvgIcons, ComponentKeys } from '@niceltd/cxone-components/shared-services';
import { trigger, state, style, transition, animate } from '@angular/animations';
import * as i1 from '@angular/platform-browser';
import * as i2 from '@niceltd/cxone-components/translation';
import { TranslationModule } from '@niceltd/cxone-components/translation';
import * as i5 from '@niceltd/cxone-components/spinner';
import { SpinnerModule } from '@niceltd/cxone-components/spinner';
import * as i6 from '@niceltd/cxone-components/overflow-tooltip';
import { OverflowTooltipModule } from '@niceltd/cxone-components/overflow-tooltip';
import * as i7 from '@niceltd/cxone-components/text-input';
import { TextInputModule } from '@niceltd/cxone-components/text-input';
import * as i8 from '@niceltd/cxone-components/infinite-scrolling';
import { InfiniteScrollingModule } from '@niceltd/cxone-components/infinite-scrolling';
import { SvgSpriteIconModule } from '@niceltd/cxone-components/svg-sprite-icon';
import { I18NEXT_NAMESPACE } from 'angular-i18next';
const _c0 = ["dropdownElement"];
const _c1 = ["inputEl"];
function SingleselectDropdownComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("title", ctx_r1.placeholder);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.placeholder);
  }
}
function SingleselectDropdownComponent_div_4_span_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
const _c2 = (a0, a1) => ({
  item: a0,
  query: a1
});
function SingleselectDropdownComponent_div_4_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, SingleselectDropdownComponent_div_4_span_2_ng_container_1_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r4.templateSelection)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c2, ctx_r4.selection, ctx_r4.query));
  }
}
function SingleselectDropdownComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, SingleselectDropdownComponent_div_4_span_2_Template, 2, 5, "span", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵattribute("title", ctx_r2.selection[ctx_r2.label]);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", !ctx_r2.templateSelection ? ctx_r2.selection[ctx_r2.label] : "", " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.templateSelection);
  }
}
function SingleselectDropdownComponent_div_6_div_1_i_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "i", 21);
    i0.ɵɵlistener("keydown.enter", function SingleselectDropdownComponent_div_6_div_1_i_5_Template_i_keydown_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const ctx_r17 = i0.ɵɵnextContext(3);
      ctx_r17.clearQuery($event);
      return i0.ɵɵresetView(ctx_r17.loadDropdown());
    })("click", function SingleselectDropdownComponent_div_6_div_1_i_5_Template_i_click_0_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const ctx_r19 = i0.ɵɵnextContext(3);
      ctx_r19.clearQuery($event);
      return i0.ɵɵresetView(ctx_r19.loadDropdown());
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHTML", ctx_r15.icons.close, i0.ɵɵsanitizeHtml);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 2, "cxone-components.dropdowns.clearQuery"));
  }
}
function SingleselectDropdownComponent_div_6_div_1_i_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 22);
  }
  if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHTML", ctx_r16.icons.search, i0.ɵɵsanitizeHtml);
  }
}
function SingleselectDropdownComponent_div_6_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16)(1, "cxone-text-input", 17, 18);
    i0.ɵɵtwoWayListener("ngModelChange", function SingleselectDropdownComponent_div_6_div_1_Template_cxone_text_input_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r21);
      const ctx_r20 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r20.query, $event) || (ctx_r20.query = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("keyup", function SingleselectDropdownComponent_div_6_div_1_Template_cxone_text_input_keyup_1_listener($event) {
      i0.ɵɵrestoreView(_r21);
      const ctx_r22 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r22.onSearch($event));
    });
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, SingleselectDropdownComponent_div_6_div_1_i_5_Template, 2, 4, "i", 19)(6, SingleselectDropdownComponent_div_6_div_1_i_6_Template, 1, 1, "i", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(3, 5, "cxone-components.dropdowns.searchingFor"));
    i0.ɵɵpropertyInterpolate("accessLabel", i0.ɵɵpipeBind1(4, 7, "cxone-components.dropdowns.searchingFor"));
    i0.ɵɵtwoWayProperty("ngModel", ctx_r6.query);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r6.query && ctx_r6.query.length > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r6.query.length === 0);
  }
}
function SingleselectDropdownComponent_div_6_div_2_i_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "i", 24);
    i0.ɵɵlistener("keydown.enter", function SingleselectDropdownComponent_div_6_div_2_i_5_Template_i_keydown_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r27);
      const ctx_r26 = i0.ɵɵnextContext(3);
      ctx_r26.clearQuery($event);
      return i0.ɵɵresetView(ctx_r26.loadDropdown());
    })("click", function SingleselectDropdownComponent_div_6_div_2_i_5_Template_i_click_0_listener($event) {
      i0.ɵɵrestoreView(_r27);
      const ctx_r28 = i0.ɵɵnextContext(3);
      ctx_r28.clearQuery($event);
      return i0.ɵɵresetView(ctx_r28.loadDropdown());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHTML", ctx_r24.icons.close, i0.ɵɵsanitizeHtml);
  }
}
function SingleselectDropdownComponent_div_6_div_2_i_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 22);
  }
  if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHTML", ctx_r25.icons.search, i0.ɵɵsanitizeHtml);
  }
}
function SingleselectDropdownComponent_div_6_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16)(1, "cxone-text-input", 17, 18);
    i0.ɵɵtwoWayListener("ngModelChange", function SingleselectDropdownComponent_div_6_div_2_Template_cxone_text_input_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r30);
      const ctx_r29 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r29.query, $event) || (ctx_r29.query = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("keyup", function SingleselectDropdownComponent_div_6_div_2_Template_cxone_text_input_keyup_1_listener($event) {
      i0.ɵɵrestoreView(_r30);
      const ctx_r31 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r31.onSearch($event));
    });
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, SingleselectDropdownComponent_div_6_div_2_i_5_Template, 1, 1, "i", 23)(6, SingleselectDropdownComponent_div_6_div_2_i_6_Template, 1, 1, "i", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(3, 5, "cxone-components.dropdowns.searchingFor"));
    i0.ɵɵpropertyInterpolate("accessLabel", i0.ɵɵpipeBind1(4, 7, "cxone-components.dropdowns.searchingFor"));
    i0.ɵɵtwoWayProperty("ngModel", ctx_r7.query);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r7.query && ctx_r7.query.length > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r7.query.length === 0);
  }
}
function SingleselectDropdownComponent_div_6_div_3_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 29);
    i0.ɵɵpipe(1, "highlight");
    i0.ɵɵpipe(2, "highlight");
  }
  if (rf & 2) {
    const ctx_r37 = i0.ɵɵnextContext();
    const item_r33 = ctx_r37.$implicit;
    const isFirst_r34 = ctx_r37.first;
    const ctx_r35 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 4, item_r33[ctx_r35.label], ctx_r35.query), i0.ɵɵsanitizeHtml)("tooltipContent", item_r33[ctx_r35.label])("tooltipPlacement", isFirst_r34 ? "bottom" : "top");
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(2, 7, item_r33[ctx_r35.label], ctx_r35.query));
  }
}
function SingleselectDropdownComponent_div_6_div_3_div_1_span_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
const _c3 = (a0, a1) => ({
  $implicit: a0,
  query: a1
});
function SingleselectDropdownComponent_div_6_div_3_div_1_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, SingleselectDropdownComponent_div_6_div_3_div_1_span_2_ng_container_1_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r33 = i0.ɵɵnextContext().$implicit;
    const ctx_r36 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r36.template)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c3, item_r33, ctx_r36.query));
  }
}
const _c4 = a0 => ({
  "active": a0
});
function SingleselectDropdownComponent_div_6_div_3_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵlistener("click", function SingleselectDropdownComponent_div_6_div_3_div_1_Template_div_click_0_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r41);
      const item_r33 = restoredCtx.$implicit;
      const ctx_r40 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r40.toggleItem(item_r33));
    });
    i0.ɵɵtemplate(1, SingleselectDropdownComponent_div_6_div_3_div_1_div_1_Template, 3, 10, "div", 28)(2, SingleselectDropdownComponent_div_6_div_3_div_1_span_2_Template, 2, 5, "span", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r33 = ctx.$implicit;
    const ctx_r32 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c4, ctx_r32.selection && item_r33[ctx_r32.primaryKey] === ctx_r32.selection[ctx_r32.primaryKey]));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r32.template);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r32.template);
  }
}
function SingleselectDropdownComponent_div_6_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r43 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵlistener("endScroll", function SingleselectDropdownComponent_div_6_div_3_Template_div_endScroll_0_listener() {
      i0.ɵɵrestoreView(_r43);
      const ctx_r42 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r42.loadMoreData());
    });
    i0.ɵɵtemplate(1, SingleselectDropdownComponent_div_6_div_3_div_1_Template, 3, 5, "div", 26);
    i0.ɵɵpipe(2, "slice");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(2, 2, ctx_r8.filteredList, 0, ctx_r8.maxItemsToDisplay))("ngForTrackBy", ctx_r8.trackByFn);
  }
}
function SingleselectDropdownComponent_div_6_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelement(1, "cxone-spinner", 31);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("isSpinner", ctx_r9.isLoading);
  }
}
function SingleselectDropdownComponent_div_6_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32)(1, "span", 33);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "cxone-components.dropdowns.noresults"));
  }
}
function SingleselectDropdownComponent_div_6_div_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r45 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 34)(1, "span", 35);
    i0.ɵɵlistener("click", function SingleselectDropdownComponent_div_6_div_6_Template_span_click_1_listener() {
      i0.ɵɵrestoreView(_r45);
      const ctx_r44 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r44.create());
    })("keydown.enter", function SingleselectDropdownComponent_div_6_div_6_Template_span_keydown_enter_1_listener() {
      i0.ɵɵrestoreView(_r45);
      const ctx_r46 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r46.create());
    });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 2, "cxone-components.dropdowns.create"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 4, "cxone-components.dropdowns.create"));
  }
}
const _c5 = (a0, a1) => ({
  count: a0,
  total: a1
});
function SingleselectDropdownComponent_div_6_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36)(1, "div", 37)(2, "div", 38);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 1, "cxone-components.dropdowns.footerText", i0.ɵɵpureFunction2(4, _c5, ctx_r12.options.length > ctx_r12.maxItemsToDisplay ? ctx_r12.maxItemsToDisplay : ctx_r12.options.length, ctx_r12.options.length)), " ");
  }
}
function SingleselectDropdownComponent_div_6_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36)(1, "div", 37)(2, "div", 38);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 1, "cxone-components.dropdowns.footerText", i0.ɵɵpureFunction2(4, _c5, ctx_r13.options.length > ctx_r13.maxItemsToDisplay ? ctx_r13.maxItemsToDisplay : ctx_r13.options.length, ctx_r13.serverSideSearch.resultsCount)), " ");
  }
}
const _c6 = a0 => ({
  transitionParams: a0,
  height: "*"
});
const _c7 = a1 => ({
  value: "visible",
  params: a1
});
const _c8 = a0 => ({
  transitionParams: a0,
  height: "0",
  border: "0"
});
const _c9 = a1 => ({
  value: "hidden",
  params: a1
});
function SingleselectDropdownComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r48 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵlistener("@dropdownContent.done", function SingleselectDropdownComponent_div_6_Template_div_animation_dropdownContent_done_0_listener($event) {
      i0.ɵɵrestoreView(_r48);
      const ctx_r47 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r47.onToggleDone($event));
    });
    i0.ɵɵtemplate(1, SingleselectDropdownComponent_div_6_div_1_Template, 7, 9, "div", 10)(2, SingleselectDropdownComponent_div_6_div_2_Template, 7, 9, "div", 10)(3, SingleselectDropdownComponent_div_6_div_3_Template, 3, 6, "div", 11)(4, SingleselectDropdownComponent_div_6_div_4_Template, 2, 1, "div", 12)(5, SingleselectDropdownComponent_div_6_div_5_Template, 4, 3, "div", 13)(6, SingleselectDropdownComponent_div_6_div_6_Template, 5, 6, "div", 14)(7, SingleselectDropdownComponent_div_6_div_7_Template, 5, 7, "div", 15)(8, SingleselectDropdownComponent_div_6_div_8_Template, 5, 7, "div", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("@dropdownContent", ctx_r3.isDropdownOpen ? i0.ɵɵpureFunction1(11, _c7, i0.ɵɵpureFunction1(9, _c6, ctx_r3.animating ? ctx_r3.transitionOptions : "0ms")) : i0.ɵɵpureFunction1(15, _c9, i0.ɵɵpureFunction1(13, _c8, ctx_r3.transitionOptions)));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r3.isLoading && ctx_r3.search && ctx_r3.serverSideSearch === undefined);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.search && ctx_r3.serverSideSearch !== undefined && ctx_r3.serverSideSearch.enabled === true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r3.isLoading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.isLoading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.query.length !== 0 && ctx_r3.filteredList.length === 0 && !ctx_r3.enableAddFreeTextItem);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.query.length !== 0 && (ctx_r3.filteredList.length === 0 || !ctx_r3.hasExactMatch) && ctx_r3.enableAddFreeTextItem);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.query.length === 0 && ctx_r3.isLoading === false && ctx_r3.serverSideSearch === undefined && ctx_r3.showFooter);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.isLoading === false && ctx_r3.serverSideSearch !== undefined && ctx_r3.serverSideSearch.enabled === true && ctx_r3.showFooter);
  }
}
const _c10 = a0 => ({
  "expanded": a0
});
const _c11 = (a0, a1) => ({
  "disabled": a0,
  "required": a1
});
const _c12 = (a0, a1) => ({
  "dropdown-open": a0,
  "dropdown-closed": a1
});
class HighlightPipe {
  transform(text, ...args) {
    const query = args[0];
    if (query) {
      const index = text.toLowerCase().indexOf(query.toLowerCase());
      if (index !== -1) {
        text = text.substring(0, index) + '<span class="highlighted">' + text.substr(index, query.length) + '</span>' + text.substring(index + query.length, text.length);
      }
    }
    return text;
  }
  /** @nocollapse */
  static {
    this.ɵfac = function HighlightPipe_Factory(t) {
      return new (t || HighlightPipe)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "highlight",
      type: HighlightPipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HighlightPipe, [{
    type: Pipe,
    args: [{
      name: 'highlight'
    }]
  }], null, null);
})();
class SingleselectDropdownComponent {
  constructor(sanitizer, translate) {
    this.sanitizer = sanitizer;
    this.translate = translate;
    this.isLoading = false;
    this.isRequired = false;
    this.label = 'name';
    this.maxItemsToDisplay = 200;
    this.options = [];
    this.placeholder = this.translate.transform('cxone-components.dropdowns.defaultPlaceholder.single');
    this.primaryKey = 'id';
    this.search = true;
    this.showFooter = true;
    this.sortOrder = 'asc';
    this.enableInfiniteScroll = false;
    this.readonly = false;
    this.enableAddFreeTextItem = false;
    this.dropdownOpened = new EventEmitter();
    this.dropdownClosed = new EventEmitter();
    this.selectionChanged = new EventEmitter();
    this.onServerSideSearch = new EventEmitter();
    this.onCreate = new EventEmitter();
    this.onLoadData = new EventEmitter();
    this.disabled = false;
    this.selection = {};
    this.displayedOptions = [];
    this.dropdownTouched = false;
    this.filteredList = [];
    this.isDropdownOpen = false;
    this.query = '';
    this.icons = {};
    this.transitionOptions = '300ms cubic-bezier(0.86, 0, 0.07, 1)';
    this.animating = false;
    this.defaultKeystrokedelay = 500;
    this.defaultResultscount = 0;
    this.hasExactMatch = false;
    this.svgIcons = new SvgIcons(this.sanitizer);
    this.onChangedCallback = _ => {}; // eslint-disable-line @typescript-eslint/no-unused-vars
    this.onTouchedCallback = _ => {}; // eslint-disable-line @typescript-eslint/no-unused-vars
    this.icons.arrow = this.svgIcons.getSvgIcons('icon-arrow-down');
    this.icons.close = this.svgIcons.getSvgIcons('icon-close');
    this.icons.search = this.svgIcons.getSvgIcons('icon-search2');
  }
  ngOnInit() {
    if (this.serverSideSearch !== undefined && this.serverSideSearch.enabled === true) {
      this.serverSideSearch.keyStrokeDelay = this.serverSideSearch.keyStrokeDelay === undefined ? this.defaultKeystrokedelay : this.serverSideSearch.keyStrokeDelay;
      this.serverSideSearch.resultsCount = this.serverSideSearch.resultsCount === undefined ? this.defaultResultscount : this.serverSideSearch.resultsCount;
    }
    this.loadDropdown();
  }
  ngOnChanges(changes) {
    if (changes.options && changes.options.currentValue && !changes.options.firstChange) {
      this.options = changes.options.currentValue;
      this.loadDropdown();
    }
    if (changes.selection && changes.selection.currentValue && !changes.selection.firstChange) {
      this.selection = changes.selection.currentValue;
      this.loadDropdown();
    }
  }
  writeValue(obj) {
    this.selection = obj;
  }
  registerOnChange(fn) {
    this.onChangedCallback = fn;
  }
  registerOnTouched(fn) {
    this.onTouchedCallback = fn;
  }
  setDisabledState(isDisabled) {
    this.disabled = isDisabled;
  }
  /* This function initialises the dropdown with the data */
  loadDropdown() {
    this.sortKey = this.sortKey === undefined ? this.label : this.sortKey;
    if (this.serverSideSearch !== undefined && this.serverSideSearch.enabled) {
      this.prepareOptionsWhenServerSearchEnabled();
    } else {
      this.prepareOptions();
    }
  }
  /* This function clears the search input field */
  clearQuery(event) {
    this.dropdownTouched = true;
    this.query = '';
    if (this.serverSideSearch !== undefined && this.serverSideSearch.enabled === true && event.cancelable === true) {
      this.serverSearch(this.query, 0);
    } else {
      this.filteredList = [...this.options];
    }
    if (event) {
      event.stopPropagation();
    }
  }
  /* This function handles the functionality when the dropdown is opened or closed */
  toggleDropdown() {
    this.animating = true;
    this.isDropdownOpen = !this.isDropdownOpen;
    if (this.isDropdownOpen) {
      this.loadDropdown();
      this.dropdownOpened.emit();
      this.focusOnInput();
    } else {
      this.dropdownTouched = true;
      this.dropdownClosed.emit();
    }
  }
  /*This function is responsible for searching query on server side based on keystroke delay*/
  serverSearch(query, timeout) {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    this.timer = setTimeout(() => {
      this.onServerSideSearch.emit({
        offset: 0,
        query: query
      });
    }, timeout);
  }
  /* This function is used to filter search results when an item is search for in the dropdown */
  onSearch(event) {
    this.dropdownTouched = true;
    this.hasExactMatch = false;
    /* Whenever the user presses the escape key inside the search field, then the query is cleared.
    If the query is already cleared and the user presses the escape key, then the dropdown is toggled off */
    if (event.keyCode === 27 && this.query.length !== 0) {
      this.clearQuery();
      return;
    } else if (event.keyCode === 27 && this.query.length === 0) {
      this.toggleDropdown();
      return;
    }
    const searchQuery = event.target.value;
    if (this.serverSideSearch !== undefined && this.serverSideSearch.enabled === true) {
      this.serverSearch(searchQuery, this.serverSideSearch.keyStrokeDelay);
    } else {
      setTimeout(() => {
        const searchResults = this.options.filter(item => {
          if (item[this.label].toLowerCase().includes(searchQuery.toLowerCase())) {
            if (item[this.label].toLowerCase() === searchQuery.toLowerCase()) {
              this.hasExactMatch = true;
            }
            return true;
          }
          return false;
        });
        this.filteredList = searchResults;
      });
    }
  }
  /* This function handles the selection or deselection of items in the dropdown */
  toggleItem(item) {
    this.selection = item;
    this.dropdownTouched = true;
    this.toggleDropdown();
    this.onChangedCallback(this.selection);
    if (this.serverSideSearch !== undefined && this.serverSideSearch.enabled === true && !this.isEmpty(this.query)) {
      this.serverSearch('', 0);
    }
    this.selectionChanged.emit({
      selected: this.selection
    });
    this.query = '';
  }
  /* This function handles focus-out event */
  onTouched() {
    if (!this.dropdownTouched) {
      this.onTouchedCallback();
      this.dropdownTouched = true;
    }
  }
  /* This function validate modal state */
  validate(control) {
    return this.isRequired ? Validators.required(control) : null;
  }
  /* This function focuses the cursor on the search input box */
  focusOnInput() {
    if (this.inputElRef) {
      this.inputElRef.nativeElement.querySelector('input[type="text"]').focus();
    }
  }
  /* This function marks the selected items in the total list of options */
  prepareOptions() {
    this.options = this.options === undefined ? [] : [...this.options];
    this.options = this.sortOptions(this.options);
    if (this.selection && this.selection !== undefined) {
      const indexOfSelectedItem = this.getIndexOfSelectedItem(this.options, this.selection);
      if (indexOfSelectedItem !== -1 && indexOfSelectedItem > this.maxItemsToDisplay) {
        this.options.splice(indexOfSelectedItem, 1);
        this.options.splice(0, 0, this.selection);
      }
    }
    this.filteredList = [...this.options];
  }
  /*This function prepare display options when server search is enabled */
  prepareOptionsWhenServerSearchEnabled() {
    let displayedOptions = [];
    this.options = this.options === undefined ? [] : [...this.options];
    this.options = this.sortOptions(this.options);
    displayedOptions = this.getSelectedItemNotAvailableInOptions(this.selection, this.options);
    this.addOptionsInFilteredList(displayedOptions, this.options);
  }
  getSelectedItemNotAvailableInOptions(selectedItem, options) {
    const displayedOptions = [];
    if (selectedItem !== undefined) {
      const indexOfSelectedItem = this.getIndexOfSelectedItem(options, selectedItem);
      if (indexOfSelectedItem === -1) {
        if (this.isEmpty(this.query)) {
          displayedOptions.push(selectedItem);
        }
      }
    }
    return displayedOptions;
  }
  addOptionsInFilteredList(displayedOptions, options) {
    let counter = displayedOptions.length;
    options.forEach(item => {
      if (counter < this.maxItemsToDisplay) {
        displayedOptions.push(item);
      }
      counter = counter + 1;
    });
    this.filteredList = displayedOptions;
  }
  getIndexOfSelectedItem(collection, selectedItem) {
    return collection.findIndex(item => item[this.primaryKey] === selectedItem[this.primaryKey]);
  }
  isEmpty(value) {
    return value === '' || value === undefined || value === null;
  }
  /* This function is responsible for sorting the list of options based on the inputs */
  sortOptions(options) {
    options.sort((a, b) => {
      if (this.sortOrder === 'asc') {
        if (typeof a[this.sortKey] === 'string') {
          return a[this.sortKey].localeCompare(b[this.sortKey]);
        }
        return a[this.sortKey] - b[this.sortKey];
      } else if (this.sortOrder === 'desc') {
        if (typeof a[this.sortKey] === 'string') {
          return b[this.sortKey].localeCompare(a[this.sortKey]);
        }
        return b[this.sortKey] - a[this.sortKey];
      } else if (this.sortOrder === 'unsort') {
        return 0;
      } else {
        return 0;
      }
    });
    return [...options];
  }
  /* This function returns the primary index of each object in the collection.
   This is done to better index and uniquely identify the options in the dropdown  */
  trackByFn() {
    return this.primaryKey;
  }
  /* This function closes the dropdown whenever there is a click outside the dropdown area */
  closeDropdown(event) {
    if (!this.dropdownElRef.nativeElement.contains(event.target) && this.isDropdownOpen) {
      this.toggleDropdown();
    }
  }
  /* Method which is executed whenever a toggle animation is complete */
  onToggleDone(_event) {
    this.animating = false;
    if (this.serverSideSearch === undefined) {
      this.clearQuery();
    }
  }
  loadMoreData() {
    if (this.enableInfiniteScroll) {
      this.onLoadData.emit();
    }
  }
  create() {
    this.onCreate.emit({
      text: this.query
    });
    this.toggleDropdown();
    this.clearQuery();
  }
  /** @nocollapse */
  static {
    this.ɵfac = function SingleselectDropdownComponent_Factory(t) {
      return new (t || SingleselectDropdownComponent)(i0.ɵɵdirectiveInject(i1.DomSanitizer), i0.ɵɵdirectiveInject(i2.TranslationPipe));
    };
  }
  /** @nocollapse */
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SingleselectDropdownComponent,
      selectors: [["cxone-singleselect-dropdown"]],
      viewQuery: function SingleselectDropdownComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 5);
          i0.ɵɵviewQuery(_c1, 5, ElementRef);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropdownElRef = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputElRef = _t.first);
        }
      },
      hostBindings: function SingleselectDropdownComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function SingleselectDropdownComponent_click_HostBindingHandler($event) {
            return ctx.closeDropdown($event);
          }, false, i0.ɵɵresolveDocument);
        }
      },
      inputs: {
        isLoading: "isLoading",
        isRequired: "isRequired",
        label: "label",
        maxItemsToDisplay: "maxItemsToDisplay",
        options: "options",
        placeholder: "placeholder",
        primaryKey: "primaryKey",
        search: "search",
        showFooter: "showFooter",
        sortKey: "sortKey",
        sortOrder: "sortOrder",
        serverSideSearch: "serverSideSearch",
        enableInfiniteScroll: "enableInfiniteScroll",
        template: "template",
        templateSelection: "templateSelection",
        readonly: "readonly",
        enableAddFreeTextItem: "enableAddFreeTextItem"
      },
      outputs: {
        dropdownOpened: "dropdownOpened",
        dropdownClosed: "dropdownClosed",
        selectionChanged: "selectionChanged",
        onServerSideSearch: "onServerSideSearch",
        onCreate: "onCreate",
        onLoadData: "onLoadData"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: SingleselectDropdownComponent,
        multi: true
      }, {
        provide: NG_VALIDATORS,
        useExisting: SingleselectDropdownComponent,
        multi: true
      }]), i0.ɵɵNgOnChangesFeature],
      decls: 7,
      vars: 16,
      consts: [[1, "cxone-singleselect-dropdown", 3, "ngClass", "focusout"], ["dropdownElement", ""], [1, "dropdown-button", 3, "ngClass", "click", "keydown.enter"], ["class", "button-text", 4, "ngIf"], [1, "icon-carat", 3, "ngClass", "innerHTML"], ["class", "dropdown-popover-wrapper", 4, "ngIf"], [1, "button-text"], [4, "ngIf"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "dropdown-popover-wrapper"], ["class", "search-wrapper", 4, "ngIf"], ["class", "options-wrapper", "cxoneInfiniteScrolling", "", 3, "endScroll", 4, "ngIf"], ["class", "loading-wrapper", 4, "ngIf"], ["class", "no-results-wrapper", 4, "ngIf"], ["class", "create-wrapper", 4, "ngIf"], ["class", "count-wrapper", 4, "ngIf"], [1, "search-wrapper"], [1, "search-box", 3, "ngModel", "placeholder", "accessLabel", "ngModelChange", "keyup"], ["inputEl", ""], ["class", "icon-close", "tabindex", "1", "role", "button", 3, "innerHTML", "keydown.enter", "click", 4, "ngIf"], ["class", "icon-search", 3, "innerHTML", 4, "ngIf"], ["tabindex", "1", "role", "button", 1, "icon-close", 3, "innerHTML", "keydown.enter", "click"], [1, "icon-search", 3, "innerHTML"], ["class", "icon-close", "tabindex", "1", 3, "innerHTML", "keydown.enter", "click", 4, "ngIf"], ["tabindex", "1", 1, "icon-close", 3, "innerHTML", "keydown.enter", "click"], ["cxoneInfiniteScrolling", "", 1, "options-wrapper", 3, "endScroll"], ["class", "item-row", 3, "ngClass", "click", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "item-row", 3, "ngClass", "click"], ["class", "item-text", "cxoneOverflowTooltip", "", "value", "top", "name", "placement", 3, "innerHTML", "tooltipContent", "tooltipPlacement", 4, "ngIf"], ["cxoneOverflowTooltip", "", "value", "top", "name", "placement", 1, "item-text", 3, "innerHTML", "tooltipContent", "tooltipPlacement"], [1, "loading-wrapper"], [3, "isSpinner"], [1, "no-results-wrapper"], [1, "no-results-text"], [1, "create-wrapper"], ["tabindex", "1", "role", "button", 1, "create-btn", 3, "click", "keydown.enter"], [1, "count-wrapper"], [1, "count-display"], [1, "count-value"]],
      template: function SingleselectDropdownComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0, 1);
          i0.ɵɵlistener("focusout", function SingleselectDropdownComponent_Template_div_focusout_0_listener() {
            return ctx.onTouched();
          });
          i0.ɵɵelementStart(2, "div", 2);
          i0.ɵɵlistener("click", function SingleselectDropdownComponent_Template_div_click_2_listener() {
            return ctx.toggleDropdown();
          })("keydown.enter", function SingleselectDropdownComponent_Template_div_keydown_enter_2_listener() {
            return ctx.toggleDropdown();
          });
          i0.ɵɵtemplate(3, SingleselectDropdownComponent_div_3_Template, 2, 2, "div", 3)(4, SingleselectDropdownComponent_div_4_Template, 3, 3, "div", 3);
          i0.ɵɵelement(5, "i", 4);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(6, SingleselectDropdownComponent_div_6_Template, 9, 17, "div", 5);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c10, ctx.isDropdownOpen));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(10, _c11, ctx.disabled === true || ctx.readonly === true, ctx.dropdownTouched === true && ctx.isRequired === true && ctx.selection === undefined));
          i0.ɵɵattribute("tabindex", ctx.disabled !== true && ctx.readonly !== true ? 1 : -1);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.selection);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.selection);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(13, _c12, ctx.isDropdownOpen, !ctx.isDropdownOpen))("innerHTML", ctx.icons.arrow, i0.ɵɵsanitizeHtml);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.isDropdownOpen);
        }
      },
      dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i3.NgTemplateOutlet, i4.NgControlStatus, i4.NgModel, i5.SpinnerComponent, i6.OverflowTooltipDirective, i7.TextInputComponent, i8.InfiniteScrollingDirective, i3.SlicePipe, i2.TranslationPipe, HighlightPipe],
      styles: [".tooltip{z-index:10000}.tooltip .highlighted{font-weight:bolder}.cxone-singleselect-dropdown{position:relative;width:100%;font-family:OpenSans}.cxone-singleselect-dropdown.expanded{box-shadow:0 2px 6px #00000017}.cxone-singleselect-dropdown.expanded .dropdown-popover-wrapper{border-bottom:1px solid rgb(208,210,211);box-shadow:0 2px 6px #00000017}.cxone-singleselect-dropdown .dropdown-button{display:flex;height:35px;border:1px solid rgb(208,210,211);background-color:#fff;align-items:center;cursor:pointer;-webkit-user-select:none;user-select:none}.cxone-singleselect-dropdown .dropdown-button.required{border:1px solid rgb(217,33,51)}.cxone-singleselect-dropdown .dropdown-button.disabled{background:#f8f8f8 0% 0% no-repeat padding-box!important;border:1px solid rgb(208,210,211)!important;opacity:1;pointer-events:none}.cxone-singleselect-dropdown .dropdown-button.disabled .button-text{color:#707e8d!important}.cxone-singleselect-dropdown .dropdown-button.disabled svg{fill:#adadad!important}.cxone-singleselect-dropdown .dropdown-button:hover:not(.required){border-color:#007cbe}.cxone-singleselect-dropdown .dropdown-button .button-text{flex:1;font-size:13px;padding:9px 15px;color:#2e2e2e;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.cxone-singleselect-dropdown .dropdown-button .icon-carat{flex-grow:0;flex-shrink:0;transform:scale(.4)}.cxone-singleselect-dropdown .dropdown-button .icon-carat svg{fill:#007cbe;position:relative;top:3px;transition:.2s;width:32px;height:32px}.cxone-singleselect-dropdown .dropdown-button .icon-carat.dropdown-open svg{transform:rotate(180deg);transition:.2s}.cxone-singleselect-dropdown .dropdown-button .icon-carat.dropdown-closed svg{transform:rotate(0);transition:.2s}.cxone-singleselect-dropdown .dropdown-popover-wrapper{position:absolute;top:35px;display:flex;flex-direction:column;background:#fff;border-left:1px solid rgb(208,210,211);border-right:1px solid rgb(208,210,211);border-top:none;width:100%;z-index:9999;overflow:hidden}.cxone-singleselect-dropdown .dropdown-popover-wrapper .search-wrapper{position:relative;padding:10px 11px}.cxone-singleselect-dropdown .dropdown-popover-wrapper .search-wrapper .cxone-text-input input[type=text]{height:30px;padding-left:6px;padding-right:30px;border:1px solid rgb(208,210,211)}.cxone-singleselect-dropdown .dropdown-popover-wrapper .search-wrapper i{position:absolute;right:0;top:0;cursor:pointer}.cxone-singleselect-dropdown .dropdown-popover-wrapper .search-wrapper i svg{fill:#adadad;transform:scale(.5);position:relative;top:10px;right:14px;width:32px;height:32px}.cxone-singleselect-dropdown .dropdown-popover-wrapper .options-wrapper{max-height:210px;overflow-y:auto;overflow-x:hidden}.cxone-singleselect-dropdown .dropdown-popover-wrapper .options-wrapper .item-row{cursor:pointer;white-space:nowrap;min-height:35px}.cxone-singleselect-dropdown .dropdown-popover-wrapper .options-wrapper .item-row .item-text{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;flex-grow:0;flex-shrink:0;font-size:13px;-webkit-user-select:none;user-select:none;width:90%;position:relative;padding-left:15px;padding-top:11px;padding-bottom:11px;color:#2e2e2e}.cxone-singleselect-dropdown .dropdown-popover-wrapper .options-wrapper .item-row .highlighted{font-weight:bolder}.cxone-singleselect-dropdown .dropdown-popover-wrapper .options-wrapper .item-row:hover:not(.active){background-color:#007cbe}.cxone-singleselect-dropdown .dropdown-popover-wrapper .options-wrapper .item-row:hover:not(.active) .item-text{color:#fff}.cxone-singleselect-dropdown .dropdown-popover-wrapper .options-wrapper .item-row.active{background-color:#d9ebf5}.cxone-singleselect-dropdown .dropdown-popover-wrapper .no-results-wrapper{padding-left:18px;padding-bottom:14px}.cxone-singleselect-dropdown .dropdown-popover-wrapper .no-results-wrapper .no-results-text{font-size:13px;color:#707e8d}.cxone-singleselect-dropdown .dropdown-popover-wrapper .create-wrapper{display:flex;color:#007cbe;padding:10px 12px 0;font-size:12px}.cxone-singleselect-dropdown .dropdown-popover-wrapper .create-wrapper span{margin-right:19px;cursor:pointer}.cxone-singleselect-dropdown .dropdown-popover-wrapper .create-wrapper span:hover{text-decoration:underline}.cxone-singleselect-dropdown .dropdown-popover-wrapper .create-wrapper span.disabled{color:#adadad;pointer-events:none}.cxone-singleselect-dropdown .dropdown-popover-wrapper .loading-wrapper{position:relative;padding:30px 0;display:flex;align-content:center;justify-content:center}.cxone-singleselect-dropdown .dropdown-popover-wrapper .loading-wrapper .p-i-icon{display:flex}.cxone-singleselect-dropdown .dropdown-popover-wrapper .count-wrapper{padding:0 15px 2px;height:35px}.cxone-singleselect-dropdown .dropdown-popover-wrapper .count-wrapper .count-display{border-top:1px solid rgb(208,210,211);font-size:12px}.cxone-singleselect-dropdown .dropdown-popover-wrapper .count-wrapper .count-display div.count-value{padding:6px 0;color:#adadad;position:relative;top:5px}\n"],
      encapsulation: 2,
      data: {
        animation: [trigger('dropdownContent', [state('hidden', style({
          height: '0'
        })), state('void', style({
          height: '{{ height }}'
        }), {
          params: {
            height: '0'
          }
        }), state('visible', style({
          height: '*'
        })), transition('visible <=> hidden', animate('{{ transitionParams }}')), transition('void <=> hidden', animate('{{ transitionParams }}')), transition('void <=> visible', animate('{{ transitionParams }}'))])]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SingleselectDropdownComponent, [{
    type: Component,
    args: [{
      selector: 'cxone-singleselect-dropdown',
      encapsulation: ViewEncapsulation.None,
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: SingleselectDropdownComponent,
        multi: true
      }, {
        provide: NG_VALIDATORS,
        useExisting: SingleselectDropdownComponent,
        multi: true
      }],
      animations: [trigger('dropdownContent', [state('hidden', style({
        height: '0'
      })), state('void', style({
        height: '{{ height }}'
      }), {
        params: {
          height: '0'
        }
      }), state('visible', style({
        height: '*'
      })), transition('visible <=> hidden', animate('{{ transitionParams }}')), transition('void <=> hidden', animate('{{ transitionParams }}')), transition('void <=> visible', animate('{{ transitionParams }}'))])],
      template: "<div class=\"cxone-singleselect-dropdown\" #dropdownElement (focusout)=\"onTouched()\" [ngClass]=\"{ 'expanded': isDropdownOpen }\">\n  <div class=\"dropdown-button\" (click)=\"toggleDropdown()\"\n       [attr.tabindex]=\"disabled !== true && readonly !== true?1:-1\" (keydown.enter)=\"toggleDropdown()\"\n    [ngClass]=\"{ 'disabled': disabled === true || readonly === true, 'required': dropdownTouched === true && isRequired === true && selection === undefined }\">\n    <div class=\"button-text\" *ngIf=\"!selection\" [attr.title]=\"placeholder\">{{ placeholder }}</div>\n    <div class=\"button-text\" *ngIf=\"selection\" [attr.title]=\"selection[label]\">{{ (!templateSelection) ? selection[label] : ''}}\n      <span *ngIf=\"templateSelection\">\n        <ng-container *ngTemplateOutlet=\"templateSelection; context: { item: selection, query: query}\"></ng-container>\n      </span>\n    </div>\n    <i class=\"icon-carat\" [ngClass]=\"{'dropdown-open': isDropdownOpen, 'dropdown-closed': !isDropdownOpen}\"\n      [innerHTML]=\"icons.arrow\"></i>\n  </div>\n  <div class=\"dropdown-popover-wrapper\" *ngIf=\"isDropdownOpen\"\n    [@dropdownContent]=\"isDropdownOpen ? { value: 'visible', params: { transitionParams: animating ? transitionOptions: '0ms', height: '*'}} : { value: 'hidden', params: { transitionParams: transitionOptions, height: '0', border: '0' }}\"\n    (@dropdownContent.done)=\"onToggleDone($event)\">\n    <div class=\"search-wrapper\" *ngIf=\"!isLoading && search && serverSideSearch === undefined\">\n      <cxone-text-input class=\"search-box\" [(ngModel)]=\"query\"\n                        placeholder=\"{{ 'cxone-components.dropdowns.searchingFor' | translate }}\"\n                        accessLabel=\"{{ 'cxone-components.dropdowns.searchingFor' | translate }}\"\n                        (keyup)=\"onSearch($event)\" #inputEl>\n      </cxone-text-input>\n      <i class=\"icon-close\" *ngIf=\"query && query.length > 0\" tabindex=\"1\" (keydown.enter)=\"clearQuery($event); loadDropdown()\" role=\"button\"\n         [attr.aria-label]=\"'cxone-components.dropdowns.clearQuery' | translate\"\n         (click)=\"clearQuery($event); loadDropdown()\"\n        [innerHTML]=\"icons.close\"></i>\n      <i class=\"icon-search\" *ngIf=\"query.length === 0\" [innerHTML]=\"icons.search\"></i>\n    </div>\n    <div class=\"search-wrapper\" *ngIf=\"search && serverSideSearch !== undefined && serverSideSearch.enabled === true\">\n      <cxone-text-input class=\"search-box\" [(ngModel)]=\"query\"\n                        placeholder=\"{{ 'cxone-components.dropdowns.searchingFor' | translate }}\"\n                        accessLabel=\"{{ 'cxone-components.dropdowns.searchingFor' | translate }}\"\n                        (keyup)=\"onSearch($event)\" #inputEl>\n      </cxone-text-input>\n      <i class=\"icon-close\" *ngIf=\"query && query.length > 0\" tabindex=\"1\" (keydown.enter)=\"clearQuery($event); loadDropdown()\"\n         (click)=\"clearQuery($event); loadDropdown()\"\n         [innerHTML]=\"icons.close\"></i>\n      <i class=\"icon-search\" *ngIf=\"query.length === 0\" [innerHTML]=\"icons.search\"></i>\n    </div>\n    <div class=\"options-wrapper\" *ngIf=\"!isLoading\" cxoneInfiniteScrolling (endScroll)=\"loadMoreData()\">\n      <div class=\"item-row\" *ngFor=\"let item of filteredList | slice:0:maxItemsToDisplay; trackBy: trackByFn, first as isFirst\"\n        (click)=\"toggleItem(item)\"\n        [ngClass]=\"{ 'active' : selection && item[primaryKey] === selection[primaryKey] }\">\n        <div class=\"item-text\" [innerHTML]=\"item[label]|highlight:query\" [attr.aria-label]=\"item[label]|highlight:query\" cxoneOverflowTooltip [tooltipContent]=\"item[label]\"  [tooltipPlacement]=\"isFirst ? 'bottom' : 'top'\" value=\"top\" name=\"placement\" *ngIf=\"!template\"></div>\n        <span *ngIf=\"template\">\n          <ng-container *ngTemplateOutlet=\"template; context: { $implicit: item, query: query }\"></ng-container>\n        </span>\n      </div>\n    </div>\n    <div class=\"loading-wrapper\" *ngIf=\"isLoading\">\n      <cxone-spinner [isSpinner]=\"isLoading\"></cxone-spinner>\n    </div>\n    <div class=\"no-results-wrapper\" *ngIf=\"query.length !== 0 && filteredList.length === 0 && !enableAddFreeTextItem\">\n      <span class=\"no-results-text\">{{ 'cxone-components.dropdowns.noresults' | translate }}</span>\n    </div>\n    <div class=\"create-wrapper\" *ngIf=\"query.length !== 0 && (filteredList.length === 0 || !hasExactMatch) && enableAddFreeTextItem\">\n      <span class=\"create-btn\" (click)=\"create()\" (keydown.enter)=\"create()\" tabindex=\"1\"\n        role=\"button\" [attr.aria-label]=\"'cxone-components.dropdowns.create' | translate\" >{{ 'cxone-components.dropdowns.create' | translate }}</span>\n    </div>\n    <div class=\"count-wrapper\" *ngIf=\"query.length === 0 && isLoading === false && serverSideSearch === undefined && showFooter\">\n      <div class=\"count-display\">\n        <div class=\"count-value\">\n          {{ 'cxone-components.dropdowns.footerText' | translate:{ count: (options.length > maxItemsToDisplay) ? maxItemsToDisplay : options.length, total: options.length } }}\n        </div>\n      </div>\n    </div>\n    <div class=\"count-wrapper\"\n         *ngIf=\"isLoading === false && serverSideSearch !== undefined && serverSideSearch.enabled === true && showFooter\">\n      <div class=\"count-display\">\n        <div class=\"count-value\">\n          {{ 'cxone-components.dropdowns.footerText' | translate:{\n          count: (options.length > maxItemsToDisplay) ? maxItemsToDisplay : options.length,\n          total: serverSideSearch.resultsCount\n        } }}\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n",
      styles: [".tooltip{z-index:10000}.tooltip .highlighted{font-weight:bolder}.cxone-singleselect-dropdown{position:relative;width:100%;font-family:OpenSans}.cxone-singleselect-dropdown.expanded{box-shadow:0 2px 6px #00000017}.cxone-singleselect-dropdown.expanded .dropdown-popover-wrapper{border-bottom:1px solid rgb(208,210,211);box-shadow:0 2px 6px #00000017}.cxone-singleselect-dropdown .dropdown-button{display:flex;height:35px;border:1px solid rgb(208,210,211);background-color:#fff;align-items:center;cursor:pointer;-webkit-user-select:none;user-select:none}.cxone-singleselect-dropdown .dropdown-button.required{border:1px solid rgb(217,33,51)}.cxone-singleselect-dropdown .dropdown-button.disabled{background:#f8f8f8 0% 0% no-repeat padding-box!important;border:1px solid rgb(208,210,211)!important;opacity:1;pointer-events:none}.cxone-singleselect-dropdown .dropdown-button.disabled .button-text{color:#707e8d!important}.cxone-singleselect-dropdown .dropdown-button.disabled svg{fill:#adadad!important}.cxone-singleselect-dropdown .dropdown-button:hover:not(.required){border-color:#007cbe}.cxone-singleselect-dropdown .dropdown-button .button-text{flex:1;font-size:13px;padding:9px 15px;color:#2e2e2e;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.cxone-singleselect-dropdown .dropdown-button .icon-carat{flex-grow:0;flex-shrink:0;transform:scale(.4)}.cxone-singleselect-dropdown .dropdown-button .icon-carat svg{fill:#007cbe;position:relative;top:3px;transition:.2s;width:32px;height:32px}.cxone-singleselect-dropdown .dropdown-button .icon-carat.dropdown-open svg{transform:rotate(180deg);transition:.2s}.cxone-singleselect-dropdown .dropdown-button .icon-carat.dropdown-closed svg{transform:rotate(0);transition:.2s}.cxone-singleselect-dropdown .dropdown-popover-wrapper{position:absolute;top:35px;display:flex;flex-direction:column;background:#fff;border-left:1px solid rgb(208,210,211);border-right:1px solid rgb(208,210,211);border-top:none;width:100%;z-index:9999;overflow:hidden}.cxone-singleselect-dropdown .dropdown-popover-wrapper .search-wrapper{position:relative;padding:10px 11px}.cxone-singleselect-dropdown .dropdown-popover-wrapper .search-wrapper .cxone-text-input input[type=text]{height:30px;padding-left:6px;padding-right:30px;border:1px solid rgb(208,210,211)}.cxone-singleselect-dropdown .dropdown-popover-wrapper .search-wrapper i{position:absolute;right:0;top:0;cursor:pointer}.cxone-singleselect-dropdown .dropdown-popover-wrapper .search-wrapper i svg{fill:#adadad;transform:scale(.5);position:relative;top:10px;right:14px;width:32px;height:32px}.cxone-singleselect-dropdown .dropdown-popover-wrapper .options-wrapper{max-height:210px;overflow-y:auto;overflow-x:hidden}.cxone-singleselect-dropdown .dropdown-popover-wrapper .options-wrapper .item-row{cursor:pointer;white-space:nowrap;min-height:35px}.cxone-singleselect-dropdown .dropdown-popover-wrapper .options-wrapper .item-row .item-text{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;flex-grow:0;flex-shrink:0;font-size:13px;-webkit-user-select:none;user-select:none;width:90%;position:relative;padding-left:15px;padding-top:11px;padding-bottom:11px;color:#2e2e2e}.cxone-singleselect-dropdown .dropdown-popover-wrapper .options-wrapper .item-row .highlighted{font-weight:bolder}.cxone-singleselect-dropdown .dropdown-popover-wrapper .options-wrapper .item-row:hover:not(.active){background-color:#007cbe}.cxone-singleselect-dropdown .dropdown-popover-wrapper .options-wrapper .item-row:hover:not(.active) .item-text{color:#fff}.cxone-singleselect-dropdown .dropdown-popover-wrapper .options-wrapper .item-row.active{background-color:#d9ebf5}.cxone-singleselect-dropdown .dropdown-popover-wrapper .no-results-wrapper{padding-left:18px;padding-bottom:14px}.cxone-singleselect-dropdown .dropdown-popover-wrapper .no-results-wrapper .no-results-text{font-size:13px;color:#707e8d}.cxone-singleselect-dropdown .dropdown-popover-wrapper .create-wrapper{display:flex;color:#007cbe;padding:10px 12px 0;font-size:12px}.cxone-singleselect-dropdown .dropdown-popover-wrapper .create-wrapper span{margin-right:19px;cursor:pointer}.cxone-singleselect-dropdown .dropdown-popover-wrapper .create-wrapper span:hover{text-decoration:underline}.cxone-singleselect-dropdown .dropdown-popover-wrapper .create-wrapper span.disabled{color:#adadad;pointer-events:none}.cxone-singleselect-dropdown .dropdown-popover-wrapper .loading-wrapper{position:relative;padding:30px 0;display:flex;align-content:center;justify-content:center}.cxone-singleselect-dropdown .dropdown-popover-wrapper .loading-wrapper .p-i-icon{display:flex}.cxone-singleselect-dropdown .dropdown-popover-wrapper .count-wrapper{padding:0 15px 2px;height:35px}.cxone-singleselect-dropdown .dropdown-popover-wrapper .count-wrapper .count-display{border-top:1px solid rgb(208,210,211);font-size:12px}.cxone-singleselect-dropdown .dropdown-popover-wrapper .count-wrapper .count-display div.count-value{padding:6px 0;color:#adadad;position:relative;top:5px}\n"]
    }]
  }], () => [{
    type: i1.DomSanitizer
  }, {
    type: i2.TranslationPipe
  }], {
    isLoading: [{
      type: Input
    }],
    isRequired: [{
      type: Input
    }],
    label: [{
      type: Input
    }],
    maxItemsToDisplay: [{
      type: Input
    }],
    options: [{
      type: Input
    }],
    placeholder: [{
      type: Input
    }],
    primaryKey: [{
      type: Input
    }],
    search: [{
      type: Input
    }],
    showFooter: [{
      type: Input
    }],
    sortKey: [{
      type: Input
    }],
    sortOrder: [{
      type: Input
    }],
    serverSideSearch: [{
      type: Input
    }],
    enableInfiniteScroll: [{
      type: Input
    }],
    template: [{
      type: Input
    }],
    templateSelection: [{
      type: Input
    }],
    readonly: [{
      type: Input
    }],
    enableAddFreeTextItem: [{
      type: Input
    }],
    dropdownOpened: [{
      type: Output
    }],
    dropdownClosed: [{
      type: Output
    }],
    selectionChanged: [{
      type: Output
    }],
    onServerSideSearch: [{
      type: Output
    }],
    onCreate: [{
      type: Output
    }],
    onLoadData: [{
      type: Output
    }],
    dropdownElRef: [{
      type: ViewChild,
      args: ['dropdownElement', {
        static: false
      }]
    }],
    inputElRef: [{
      type: ViewChild,
      args: ['inputEl', {
        static: false,
        read: ElementRef
      }]
    }],
    closeDropdown: [{
      type: HostListener,
      args: ['document:click', ['$event']]
    }]
  });
})();
class SingleselectDropdownModule {
  /** @nocollapse */static {
    this.ɵfac = function SingleselectDropdownModule_Factory(t) {
      return new (t || SingleselectDropdownModule)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: SingleselectDropdownModule
    });
  }
  /** @nocollapse */
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [{
        provide: I18NEXT_NAMESPACE,
        useValue: ComponentKeys.TRANSLATION_NAMESPACE
      }],
      imports: [CommonModule, FormsModule, SpinnerModule, SvgSpriteIconModule, OverflowTooltipModule, TextInputModule, TranslationModule, InfiniteScrollingModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SingleselectDropdownModule, [{
    type: NgModule,
    args: [{
      declarations: [SingleselectDropdownComponent, HighlightPipe],
      imports: [CommonModule, FormsModule, SpinnerModule, SvgSpriteIconModule, OverflowTooltipModule, TextInputModule, TranslationModule, InfiniteScrollingModule],
      providers: [{
        provide: I18NEXT_NAMESPACE,
        useValue: ComponentKeys.TRANSLATION_NAMESPACE
      }],
      exports: [SingleselectDropdownComponent]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { HighlightPipe, SingleselectDropdownComponent, SingleselectDropdownModule };
